export const libName = 'ui-components';
export * from './icon/src/icon/ellipse-icon.module';
export * from './icon/src/icon/icon.component';
